import { useQueryClient } from "@tanstack/react-query"
import { DefaultCompetitorModal } from "../CompetitorsCollapse/layout/DefaultCompetitorModal/DefaultCompetitorModal"
import { useAddCompetitor } from "hooks/api/competitors/competitors.hook"
import { useMessage } from "hooks/message.hook"
import { useApiErrorFormatter } from "hooks/apiErrorFormatter.hook"

type Props = { isModalOpen: boolean; setModalClose: () => void }

export const AddCompetitorModal = ({ isModalOpen, setModalClose }: Props) => {
	const queryClient = useQueryClient()
	const { mutate: addCompetitorMutation } = useAddCompetitor()
	const { success } = useMessage()
	const { formatError } = useApiErrorFormatter()

	const onSaveHandle = (name: string) => {
		addCompetitorMutation(name, {
			onSuccess: () => {
				setModalClose()
				success("Competitor added successfully")
				// Invalidate and refetch competitors query
				queryClient.invalidateQueries({ queryKey: ["getCompetitors"] })
			},
			onError: (e) => {
				formatError(e)
			},
		})
	}

	return (
		<DefaultCompetitorModal
			isModalOpen={isModalOpen}
			setModalClose={setModalClose}
			title="Add competitor"
			inputLabel="Competitor name"
			validationMessage="Please enter competitor name"
			cancelButtonText="Cancel"
			saveButtonText="Save"
			onSave={onSaveHandle}
		/>
	)
}
